/* eslint-disable no-console */
import axios from 'axios';

import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import CRUDMethods from '../../../constants/CRUDConstants';
import useJSONStore from '../../../store/StaticJson/jsonStore';
import useUserStore from '../../../store/userStore/userStore';

const emissionSource = async (): Promise<any> => {
  const emissionSource = useJSONStore.getState().emissionSource;
  const token = useUserStore.getState().userToken;
  const setEmissionSource = useJSONStore.getState().setEmissionSource;

  if (emissionSource.length === 0) {
    await axios
      .request({
        method: CRUDMethods.GET,
        url: `${API_BASE_URL}${API_ENDPOINT_JSON.JSON.emissionSource}`,
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: {},
        data: {}
      })
      .then((res) => {
        setEmissionSource(res.data.data);
      })
      .catch((err) => {
        return err.message;
      });
  }
};

export default emissionSource;
